import React from "react";
import { Button } from "react-bootstrap";
import * as microsoftTeams from "@microsoft/teams-js";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { CONNECT_BASE_URL } from "../utility/constants";

const MobileInvite = (props) => {
  const navigate = useNavigate();
  // const GiventID = useSelector((state) => state?.donation?.giventID || 0);
  // const formSettings = useSelector(
  //   (state) => state?.donation?.formSettings || {},
  // );
  const recordindex = useSelector(
    (state) => state?.donation?.useraccountinfo || {},
  );
  // const teamsuserData = useSelector(
  //   (state) => state?.donation?.teamsData || [],
  // );

  const onAllow = () => {
    login(props.chatId);
  };

  const onDeny = () => {
    navigate("/loadform", { state: { showDForm: true } });
  };

  const login = async (mId) => {
    try {
      await microsoftTeams.app.initialize();
      const contexts = await microsoftTeams.app.getContext();

      const chatId = contexts.chat?.id || contexts.meeting?.chatId;

      let token = await getGraphTokenMobile();

      if (token) {
        const response = await fetch(
          `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              body: {
                content: `Hello <at id="0">everyone</at>! <attachment id="1"></attachment>`, // Fallback text if Adaptive Cards are not supported
                contentType: "html", // Use "html" to support rich formatting
              },
              mentions: [
                {
                  id: 0,
                  mentionText: "everyone",
                  mentioned: {
                    conversation: { id: chatId },
                  },
                },
              ],
              importance: "urgent",
              attachments: [
                {
                  id: "1",
                  contentType: "application/vnd.microsoft.card.adaptive",
                  content: JSON.stringify({
                    type: "AdaptiveCard",
                    version: "1.4",
                    body: [
                      {
                        type: "TextBlock",
                        text: "🎉 Your donation form is ready!",
                        wrap: true,
                        weight: "Bolder",
                        size: "Large",
                      },
                      {
                        type: "TextBlock",
                        text: "Go to your meeting and click on the **Givent tab** (in the meeting tabs/content bar) from the top bar to start your donation.",
                        wrap: true,
                        spacing: "Medium",
                      },
                      {
                        type: "TextBlock",
                        text: "Donations are not supported inside the Teams mobile app. Tap below to continue in your browser.",
                        wrap: true,
                      },
                    ],
                    actions: [
                      {
                        type: "Action.OpenUrl",
                        title: "Givent",
                        url : `${CONNECT_BASE_URL}/${recordindex.formGUID}`
                        //url: `${PAYQUICKLY_BASE_URL}?guid=${recordindex.formGUID}&giventId=${GiventID}&eventId=${teamsuserData.meetingId}&trk=${formSettings.Tracker}&sku=${formSettings.GiventSKU}&fheader=${formSettings.FormHeader}`, // Your deep link here
                      },
                    ],
                  }),
                },
              ],
            }),
          },
        );

        if (response.ok) {
          console.log("Message sent successfully!", await response.json());

          navigate("/loadform", { state: { showDForm: true } });
        } else {
          const error = await response.json();
          console.error("Error sending message:", error);
        }
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const getGraphTokenMobile = async () => {
    await microsoftTeams.app.initialize();

    const teamsToken = await microsoftTeams.authentication.authenticate({
      url: `${window.location.origin}/auth`, // The page we built
      width: 600,
      height: 535,
    });
    if (teamsToken) return teamsToken;
  };

  return (
    <div className="recurring_transaction_container">
      <div className="recurring_transaction_wrapper">
        <div className="recurring_transaction_card mt_2">
          <div className="recurring_transaction_card_body">
            <div className="transaction_info_wrapper">
              <div className="form_input_wrapper">
                <p className="mt_2">
                  <b>
                    Givent wants to send an invitation to all meeting
                    participants
                  </b>
                </p>
              </div>
              <div
                className="form_input_wrapper d-flex justify-content-between"
                style={{ margin: "2rem" }}
              >
                <Button className="modal-button allow" onClick={onAllow}>
                  Allow
                </Button>
                <Button className="modal-button deny" onClick={onDeny}>
                  Deny
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileInvite;
